import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Snippet from "../components/snippet"
import ClosedBeta from "../components/closedBeta"

const ClosedBetasPage = ({ data }) => (
	<Layout
		meta={{
			title: "Closed Betas",
			description:
				"Accento Digital hosts weekly pre-conference events where organizers, speakers, and participants get to know one another.",
			keywords: "Java conference Karlsruhe",
			path: "/",
		}}
		wide
	>
		<Snippet id="closed-betas-intro" />
		{data.betas.nodes.map(beta => (
			<ClosedBeta date={beta.frontmatter.date} />
		))}
		<Snippet id="closed-betas-outro" />
	</Layout>
)

export const query = graphql`
	{
		betas: allMarkdownRemark(
			filter: { fields: { collection: { eq: "pre" } } }
			sort: { fields: frontmatter___date, order: ASC }
		) {
			nodes {
				frontmatter {
					date
				}
			}
		}
	}
`

export default ClosedBetasPage
